import { render, staticRenderFns } from "./BanHammer.vue?vue&type=template&id=e3d7a6c4"
import script from "./BanHammer.vue?vue&type=script&lang=js"
export * from "./BanHammer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports